import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Settings = props => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d={
        `M12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 C9.790861,8 8,9.790861 8,12 
        C8,14.209139 9.790861,16 12,16 Z M12,18 C8.6862915,18 6,15.3137085 6,12 C6,8.6862915 8.6862915,6 12,6 
        C15.3137085,6 18,8.6862915 18,12 C18,15.3137085 15.3137085,18 12,18 Z`
      }
      fill="currentcolor"
      fillRule="nonzero"
    />
    <path
      d={
        `M3.95528796,3.228 C4.15355233,3.04036364 4.46648851,3.04145455 4.66689628,3.22581818 C5.33885171,3.84436364 
        6.35053582,3.98290909 7.17788765,3.49745455 C8.00523948,3.01090909 8.39426631,2.04654545 8.20136045,1.14436364 
        C8.14348869,0.874909091 8.29781338,0.6 8.5571646,0.520363636 C9.64601105,0.182181818 10.8023746,0 12.0005343,0 
        C13.1976224,0 14.3539859,0.182181818 15.4439041,0.520363636 C15.7021836,0.6 15.8565083,0.874909091 
        15.7997082,1.14436364 C15.6068024,2.04654545 15.9947575,3.01090909 16.823181,3.49745455 C17.6494612,3.98290909 
        18.6611453,3.84436364 19.3331007,3.22581818 C19.5335085,3.04145455 19.8475163,3.04036364 20.044709,3.228 
        C21.7283486,4.82945455 22.9511574,6.92618182 23.487007,9.29127273 C23.5491656,9.56509091 23.3819805,9.83890909 
        23.1204859,9.92618182 C22.2641982,10.212 21.6458277,11.0323636 21.6458277,12 C21.6458277,12.9676364 
        22.2641982,13.788 23.1204859,14.0738182 C23.3819805,14.1610909 23.5491656,14.4349091 23.487007,14.7087273 
        C22.9511574,17.0727273 21.7283486,19.1705455 20.044709,20.772 C19.8475163,20.9596364 19.5335085,20.9585455 
        19.3331007,20.7741818 C18.6611453,20.1556364 17.6494612,20.0170909 16.823181,20.5025455 C15.9947575,20.9890909 
        15.6068024,21.9534545 15.7997082,22.8556364 C15.8565083,23.124 15.7021836,23.4 15.4439041,23.4796364 
        C14.3539859,23.8178182 13.1976224,24 12.0005343,24 C10.8023746,24 9.64601105,23.8178182 8.5571646,23.4796364 
        C8.29781338,23.4 8.14348869,23.124 8.20136045,22.8556364 C8.39426631,21.9534545 8.00523948,20.9890909 
        7.17788765,20.5025455 C6.35053582,20.0170909 5.33885171,20.1556364 4.66689628,20.7741818 
        C4.46648851,20.9585455 4.15355233,20.9596364 3.95528796,20.772 C2.27164842,19.1705455 1.04883956,17.0727273 
        0.51298993,14.7087273 C0.450831373,14.4349091 0.618016458,14.1610909 0.880582777,14.0738182 C1.73687049,13.788 
        2.35524096,12.9676364 2.35524096,12 C2.35524096,11.0323636 1.73687049,10.212 0.880582777,9.92618182 
        C0.618016458,9.83890909 0.450831373,9.56509091 0.51298993,9.29127273 C1.04883956,6.92618182 
        2.27164842,4.82945455 3.95528796,3.228 Z M2.72289906,8.6910312 C3.70344377,9.46411738 4.31648127,10.6716004 
        4.31648127,12 C4.31648127,13.3280196 3.70379443,14.5351918 2.72284206,15.3086045 C3.1290776,16.4877819 
        3.75037089,17.577547 4.54986117,18.5222071 C5.69634127,18.0445316 7.02777923,18.1070294 8.1576521,18.7699911 
        C9.28525031,19.4331042 10.0052265,20.5762278 10.1732485,21.8276552 C10.7704015,21.9418647 11.3812586,22 
        12.0005343,22 C12.6188636,22 13.2292295,21.9419175 13.8271844,21.8275363 C13.9949771,20.5765354 
        14.7150925,19.4326723 15.8441139,18.7695813 C16.9723039,18.1067492 18.303557,18.044366 19.4499271,18.5219926 
        C20.250109,17.5763394 20.8711536,16.4869021 21.2772292,15.3082272 C20.297233,14.5351105 19.6845874,13.3279749 
        19.6845874,12 C19.6845874,10.6719732 20.2972809,9.46479499 21.277371,8.69167314 C20.8714701,7.51309428 
        20.2504815,6.42385262 19.4499157,5.47793045 C18.3034295,5.95563834 16.9723114,5.89325521 15.8443682,5.23056813 
        C14.7144276,4.56693724 13.9940591,3.42198666 13.8263971,2.17221714 C13.2292468,2.05808415 12.6188723,2 
        12.0005343,2 C11.3819103,2 10.7716873,2.05801301 10.173664,2.17243835 C10.0055786,3.42308748 
        9.28516939,4.56694312 8.15600217,5.23097806 C7.02733272,5.89323285 5.69622991,5.95554047 4.55001591,5.47797838 
        C3.74976695,6.42354124 3.12889458,7.51248929 2.72289906,8.6910312 Z`
      }
      fill="currentcolor"
      fillRule="nonzero"
    />

  </SvgIcon>
);


export default Settings;
